import firebase from 'firebase/app'
import "firebase/auth"
import "firebase/firestore"
import "firebase/storage"

const app = firebase.initializeApp({
    // apiKey: process.env.REACT_APP_API_KEY,
    // authDomain: process.env.REACT_APP_aUTH_DOMAIN,
    // projectId: process.env.REACT_APP_PROJECT_ID,
    // storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    // messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    // appId: process.env.REACT_APP_APP_IP
    apiKey: "AIzaSyAzTzs7v5qrDaywhAB8RbHkQDcQc9AQqFA",
    authDomain: "sfe-tutor-bolt.firebaseapp.com",
    projectId: "sfe-tutor-bolt",
    storageBucket: "sfe-tutor-bolt.appspot.com",
    messagingSenderId: "97304382274",
    appId: "1:97304382274:web:c88e0a83874083ce9d96db"
})
const firestore = app.firestore()
export const storage = app.storage()
export const database = {
    users: firestore.collection('users'),
    messageRooms: firestore.collection('message_rooms'),
    messages: firestore.collection('messages'),
    ranks: firestore.collection('ranks'),
    reviews: firestore.collection('reviews'),
    announcements: firestore.collection('announcements'),
    doc_data_subjects: firestore.collection('tutorbolt_data').doc("subjects"),
    doc_data_courseTypes: firestore.collection('tutorbolt_data').doc("couresTypes"),
    doc_data_locations: firestore.collection('tutorbolt_data').doc("locations"),
    formattedDoc : doc=> {
        return { id : doc.id , ...doc.data() }
    },
    //get current time of server
    getCurrentTimeStamp:firebase.firestore.FieldValue.serverTimestamp,

    //realtime

}
export const auth = app.auth()
export default app
